import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaTachometerAlt, FaTasks, FaUser, FaLink } from "react-icons/fa";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { signOut } from "firebase/auth";
import { auth } from "../../firebase"; // Adjust path if needed
import "./home.css";

import market from "../asserts/realistic-desktop-screen-website-mockup-155229-1-1100x734.webp";
import ad2 from "../asserts/08.jpg";
import ad3 from "../asserts/R.jpeg";

const adImages = [market, ad2, ad3];

const HomePage = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [currentAd, setCurrentAd] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentAd((prevAd) => (prevAd + 1) % adImages.length);
    }, 7000);

    return () => clearInterval(interval);
  }, []);

  const nextAd = () => {
    setCurrentAd((prevAd) => (prevAd + 1) % adImages.length);
  };

  const prevAd = () => {
    setCurrentAd((prevAd) => (prevAd - 1 + adImages.length) % adImages.length);
  };

  // 🔐 Handle logout
  const handleLogout = async () => {
    try {
      await signOut(auth);
      console.log("User signed out.");
      navigate("/login"); // Redirect after logout
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  return (
    <div className="home-page">
      <nav className={`sidebar ${menuOpen ? "open" : ""}`}>
        <button className="close-menu" onClick={() => setMenuOpen(false)}>✖</button>
        <ul>
          <li onClick={() => navigate("/dashboard")}>🏠 Dashboard</li>
          <li onClick={() => navigate("/tasks")}>📋 Tasks</li>
          <li onClick={() => navigate("/withdraw")}>💸 Withdraw</li>
          <li onClick={() => navigate("/settings")}>⚙️ Settings</li>
        </ul>
      </nav>

      <header className="home-header">
        <button className="menu-btn" onClick={() => setMenuOpen(true)}>☰</button>
        <button className="logout-btn" onClick={handleLogout}>Logout</button>
      </header>

      <main className="home-content">
        <div className="ad-slider">
          <button className="prev-btn" onClick={prevAd}>
            <IoIosArrowBack size={30} />
          </button>
          <img src={adImages[currentAd]} alt="Advertisement" className="ad-image slide-animation" />
          <button className="next-btn" onClick={nextAd}>
            <IoIosArrowForward size={30} />
          </button>
        </div>
      </main>

      <footer className="footer-nav">
        <button onClick={() => navigate("/dashboard")}><FaTachometerAlt size={20} /> Dashboard</button>
        <button onClick={() => navigate("/tasks")}><FaTasks size={20} /> Tasks</button>
        <button onClick={() => navigate("/profile")}><FaUser size={20} /> Profile</button>
        <button onClick={() => navigate("/referral")}><FaLink size={20} /> Referral</button>
      </footer>
    </div>
  );
};

export default HomePage;
